import React from 'react'
import { ReactComponent as ThankyouImage } from "../../../images/thank-you/success.svg"
import "./productThankYou.scss"
import StepButton from '../../common/StepButton'
import { webBaseUrl } from '../../../config'
import { useSelector } from 'react-redux'

function ProductThankYouPage() {
 
 return (
    <div className='product-thankyou-page-container'>
      <div className='product-thankyou-page-content-container ModelMaxWidth540'>
        <ThankyouImage />
        <h1>Thank you for completing the consultation</h1>
        <p>Consultation form has been sent to the medical team. If they have any questions, they'll contact you directly. We aim to process your request within one working day.</p>

        <StepButton label={'Continue shopping '} blue={true} onClick={() => { window.location.href = webBaseUrl + "/shop " }} />
      </div>

    </div>
  )
}

export default ProductThankYouPage